export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#0E2E3B',
    contrastText: '#FFFFFF',
    light: '#E9F3F6',
  },
  secondary: {
    main: '#FFFFFF',
    contrastText: '#092028',
  },
  text: {
    primary: '#0E2E3B',
    primaryLight: '#9BA3A8',
    secondary: '#697883',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    alternate: '#57D4FF'
  },
  divider: '#E4E8ED',
  background: {
    main: '#D9D9D9',
    paper: '#FFF',
    default: '#FFF',
    footer: '#002855',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#0E2E3B',
    tableSubhead: '#E9F3F6',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    light: 'rgba(255, 255, 255, 0.3)'
  },
  verticalBar: {
    used: '#0E2E3B',
    unused: '#0E2E3B',
    unlimited: '#C0C0C0',
  }
};
